import {parseDocument} from "yaml";

const YAML_ERRORS = {
    TAB_AS_INDENT: "l'indentazione va fatta con spazi, non con tabulazioni",
    BAD_INDENT: "indentazione non corretta",
    DUPLICATE_KEY: "chiave ripetuta nello stesso caso",
    MISSING_CHAR: "manca un carattere (per esempio i due punti o un apice di chiusura)",
    UNEXPECTED_TOKEN: "testo inatteso: se contiene i due punti, mettilo tra apici",
    BLOCK_AS_IMPLICIT_KEY: "dopo i due punti serve uno spazio o un a capo",
    MULTILINE_IMPLICIT_KEY: "una chiave non può andare su più righe"
};

export function describeYamlError(error) {
    const position = error.linePos?.[0];
    const reason = YAML_ERRORS[error.code]
        ?? error.message.split('\n')[0].replace(/\s+at line \d+, column \d+:?$/, '');
    return `Il YAML non è valido${position ? ` (riga ${position.line}, colonna ${position.col})` : ''}: ${reason}.`;
}

/**
 * Turns the YAML typed in the editor into the cases the backend expects.
 * Accepts the request shape ({cases: [...]}) or directly the list of cases; JSON is valid YAML too.
 *
 * @return {{cases: ?Array, error: ?string}} no cases and no error when the text is empty
 */
export function parseDlvTests(text) {
    if (text.trim() === '') {
        return {cases: null, error: null};
    }

    const document = parseDocument(text);
    if (document.errors.length > 0) {
        return {cases: null, error: describeYamlError(document.errors[0])};
    }

    const data = document.toJS();
    const cases = Array.isArray(data) ? data : data?.cases;
    if (!Array.isArray(cases)) {
        return {cases: null, error: 'Il YAML deve contenere l\'elenco "cases".'};
    }
    if (cases.length === 0) {
        return {cases: null, error: 'L\'elenco dei casi è vuoto.'};
    }

    const normalized = [];
    for (let i = 0; i < cases.length; i++) {
        const testCase = cases[i];
        const number = i + 1;
        if (typeof testCase?.facts !== 'string' || testCase.facts.trim() === '') {
            return {cases: null, error: `Il caso ${number} non ha i fatti ("facts").`};
        }
        if (!Array.isArray(testCase.expected) || testCase.expected.length === 0) {
            return {cases: null, error: `Il caso ${number} non ha atomi attesi ("expected").`};
        }
        if (testCase.expected.some(atom => typeof atom !== 'string')) {
            return {
                cases: null,
                error: `Nel caso ${number} ogni atomo atteso deve essere un testo: se contiene i due punti, scrivilo tra apici.`
            };
        }
        if (testCase.expected.some(atom => atom.trim() === '')) {
            return {cases: null, error: `Nel caso ${number} c'è un atomo atteso vuoto.`};
        }
        if (testCase.description != null && typeof testCase.description !== 'string') {
            return {cases: null, error: `Nel caso ${number} la descrizione ("description") deve essere un testo.`};
        }

        normalized.push({
            description: testCase.description ?? undefined,
            facts: testCase.facts,
            expected: testCase.expected
        });
    }
    return {cases: normalized, error: null};
}
